import bowser from 'bowser'
import {IS_BROWSER, MIN_BROWSERS} from '../constants/environment'
import {get} from './object'

const oldBrowser = (browserList) => {
  if (!IS_BROWSER) return false
  // Check if the browser is NOT NEW
  return !Object.keys(browserList).some((key) => {
    const browser = get(key, bowser)
    if (typeof bowser.version !== 'undefined') {
      return browser && bowser.version >= browserList[key]
    }
    // Show browser as supported if browser version cannot be determined but browser name exists on browserList
    return browser
  })
}

export const isOldBrowser = () => oldBrowser(MIN_BROWSERS)



// WEBPACK FOOTER //
// ./src/utils/environment.js